import React from 'react'
import { Route, Routes } from 'react-router-dom'

import InternalError from '@/shared/ui/http-exceptions/internal-error'
import NotFound from '@/shared/ui/http-exceptions/not-found'

const Auth = React.lazy(() => import('@/pages/auth'))
const Login = React.lazy(() => import('@/pages/auth/login'))
const Register = React.lazy(() => import('@/pages/auth/register'))
const Demo = React.lazy(() => import('@/pages/demo'))
const ForgotPassword = React.lazy(() => import('@/pages/auth/forgot-password'))
const UserDataAggreement = React.lazy(
  () => import('@/pages/user-data-agreement'),
)
const PrivacyPolicy = React.lazy(() => import('@/pages/privacy-policy'))
const Root = React.lazy(() => import('@/pages/root'))
const Profile = React.lazy(() => import('@/pages/profile'))
const ProfileInfo = React.lazy(() => import('@/pages/profile/profile-info'))
const ProfileChangePassword = React.lazy(
  () => import('@/pages/profile/profile-change-password'),
)
const Admin = React.lazy(() => import('@/pages/admin'))
const AdminUser = React.lazy(() => import('@/pages/admin/admin-user'))
const AdminRole = React.lazy(() => import('@/pages/admin/admin-role'))
const Organization = React.lazy(() => import('@/pages/organization'))
const Service = React.lazy(() => import('@/pages/service'))
const Upload = React.lazy(() => import('@/pages/upload'))
const UploadData = React.lazy(() => import('@/pages/upload/upload-data'))
const UploadHistory = React.lazy(() => import('@/pages/upload/upload-history'))
const Office = React.lazy(() => import('@/pages/office'))
const Settings = React.lazy(() => import('@/pages/settings'))
const Knowledge = React.lazy(() => import('@/pages/knowledge'))
const KnowledgeItem = React.lazy(
  () => import('@/pages/knowledge/knowledge-item'),
)

const Router = () => {
  return (
    // <Suspense fallback={<Spin size="large" />}>
    <Routes>
      <Route path="/auth" element={<Auth />}>
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
      </Route>
      <Route path="/user-data-agreement" element={<UserDataAggreement />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/demo" element={<Demo />} />
      <Route path="/" element={<Root />}>
        <Route path="profile" element={<Profile />}>
          <Route path="info" element={<ProfileInfo />} />
          <Route path="change-password" element={<ProfileChangePassword />} />
        </Route>
        <Route path="admin" element={<Admin />}>
          <Route path="users" element={<AdminUser />} />
          <Route path="roles" element={<AdminRole />} />
        </Route>
        <Route path="organization" element={<Organization />} />
        <Route path="service" element={<Service />} />
        <Route path="upload" element={<Upload />}>
          <Route path="data" element={<UploadData />} />
          <Route path="history" element={<UploadHistory />} />
        </Route>
        <Route path="office" element={<Office />} />
        <Route path="settings" element={<Settings />}></Route>
        <Route path="knowledge">
          <Route index element={<Knowledge />} />
          <Route path=":section">
            <Route index element={<KnowledgeItem />} />
            <Route path=":item" element={<KnowledgeItem />} />
          </Route>
        </Route>
      </Route>
      <Route path="/error" element={<InternalError />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
    // </Suspense>
  )
}

export default Router
